import {
  renewalPayCallback,
  renewalPayOrder,
} from '@/api/renewalpayorderserv'

export default {
  state: {
    state_RenewalPayOrder_RenewalPayCallbackResult: null,
    state_RenewalPayOrder_RenewalPayOrderResult: null,
  },
  mutations: {
    SET_RENEWALPAYORDER_RENEWALPAYCALLBACK_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_RenewalPayCallbackResult = rst;
    },
    SET_RENEWALPAYORDER_RENEWALPAYORDER_RESULT: (state, rst) => {
      state.state_RenewalPayOrder_RenewalPayOrderResult = rst;
    },
  },
  actions: {
    RenewalPayOrderServ_RenewalPayCallback({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        renewalPayCallback(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_RENEWALPAYCALLBACK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_RENEWALPAYCALLBACK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    RenewalPayOrderServ_RenewalPayOrder({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        renewalPayOrder(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RENEWALPAYORDER_RENEWALPAYORDER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RENEWALPAYORDER_RENEWALPAYORDER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_RenewalPayOrder_RenewalPayCallbackResult: state => {
      return state.state_RenewalPayOrder_RenewalPayCallbackResult;
    },
    get_RenewalPayOrder_RenewalPayOrderResult: state => {
      return state.state_RenewalPayOrder_RenewalPayOrderResult;
    },
  }
}